import CostIcon from "assets/icons/FormulaCostIcon";
import useResponsive from "helpers/useResponsive";
import BasicButton from "components/BasicInputs/BasicButton";
import PlusIcon from "assets/icons/PlusIcon";
import { useFormikContext } from "formik";
import shortid from "shortid";
import Fee from "./fee";

export default function Costs() {
  const { isMobile } = useResponsive();
  const { values, setFieldValue } = useFormikContext<MaterialOrderData>();

  return (
    <div className={`${isMobile && "px-3"}`}>
      <div className="flex items-end gap-4 mb-10">
        <CostIcon />
        <span className="text-lg">هزینه سربار</span>
      </div>

      <div className="flex flex-col gap-8">
        {values.costs.map((item) => (
          <Fee key={item.ind} {...item} />
        ))}
      </div>

      <BasicButton
        className="text-[#1062D0] bg-[#D6E4FF] py-2 pr-3 pl-6 mt-8"
        variant="text"
        onClick={() => {
          const newRows = [...(values.costs || [])];
          newRows.push({
            ind: shortid.generate(),
            amount: 0,
            type: "price",
            value: 0,
            isCreditor: false,
            label: "cost",
          });
          setFieldValue("costs", newRows);
        }}
      >
        <PlusIcon scale={0.7} />
        <span>افزودن</span>
      </BasicButton>
    </div>
  );
}
